import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function AdSlot() {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch(e) {}
  }, []);

  return (
    <div className="ad-slot-wrap">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-3720833629798525"
        data-ad-slot="8666097386"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

export function Breadcrumb({ label }) {
  return (
    <div className="breadcrumb">
      <Link to="/">Home</Link> › {label}
    </div>
  );
}

export function InsightBox({ text }) {
  return (
    <div className="insight-box">
      <div className="insight-title">What this means for you</div>
      <div className="insight-text">{text}</div>
    </div>
  );
}

export function AffiliateCard({ name, desc, cta, href }) {
  return (
    <div className="affiliate-card">
      <div className="aff-text">
        <div className="aff-label">Partner</div>
        <div className="aff-name">{name}</div>
        <div className="aff-desc">{desc}</div>
      </div>
      <a href={href || '#'} target="_blank" rel="noopener noreferrer sponsored" className="aff-cta">{cta} →</a>
    </div>
  );
}

export function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-q" onClick={() => setOpen(!open)}>
        {q}
        <span className={`faq-icon${open ? ' open' : ''}`}>+</span>
      </button>
      {open && <div className="faq-a">{a}</div>}
    </div>
  );
}

export function InputSlider({ label, value, min, max, step, onChange, display }) {
  const [editing, setEditing] = useState(false);
  const [raw, setRaw] = useState('');

  // Extract just the numeric part from display string for editing
  const numericValue = value;

  const displayStr = String(display);
  const prefix = displayStr.replace(/[\d,.\s]+.*$/, '');
  const suffix = displayStr.replace(/^.*?[\d,.\s]+/, '').replace(/[\d,\s]/g, '').trim();

  const startEdit = () => {
    setRaw(String(numericValue));
    setEditing(true);
  };

  const commitEdit = () => {
    const parsed = parseFloat(raw.replace(/,/g, ''));
    if (!isNaN(parsed)) {
      const clamped = Math.min(max, Math.max(min, parsed));
      onChange(clamped);
    }
    setEditing(false);
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') commitEdit();
    if (e.key === 'Escape') setEditing(false);
  };

  return (
    <div className="input-group">
      <div className="input-label">
        <span>{label}</span>
        {editing ? (
          <div className="input-value-edit">
            {prefix && <span className="unit-hint">{prefix}</span>}
            <input
              type="number"
              className="inline-number-input"
              value={raw}
              autoFocus
              onChange={e => setRaw(e.target.value)}
              onBlur={commitEdit}
              onKeyDown={handleKey}
              min={min}
              max={max}
              step={step}
            />
            {suffix && <span className="unit-hint">{suffix}</span>}
          </div>
        ) : (
          <span className="input-value" onClick={startEdit} title="Click to type a value" style={{ cursor: 'text' }}>
            {display} <span style={{ fontSize: '0.6rem', opacity: 0.6, marginLeft: 2 }}>✎</span>
          </span>
        )}
      </div>
      <input type="range" min={min} max={max} step={step} value={value} onChange={e => onChange(+e.target.value)} />
    </div>
  );
}

export function ToggleGroup({ options, value, onChange }) {
  return (
    <div className="toggle-group">
      {options.map(opt => (
        <button
          key={opt.value}
          className={`toggle-btn${value === opt.value ? ' active' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export function ResultItem({ label, value, variant }) {
  return (
    <div className={`result-item${variant ? ' ' + variant : ''}`}>
      <div className="result-item-label">{label}</div>
      <div className="result-item-value">{value}</div>
    </div>
  );
}

export function PageFooter() {
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-bottom">
          <div className="footer-disclaimer">
            FinanceCalculator.cc calculators are for educational purposes only and do not constitute financial advice.
            Always consult a qualified financial professional before making major financial decisions.
            All calculations happen in your browser — we never store or transmit your financial data.
          </div>
          <div className="footer-copy">© 2026 FinanceCalculator.cc — <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Privacy Policy</Link> · Made with ☕</div>
        </div>
      </div>
    </footer>
  );
}
